import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

interface NavItemProps extends HTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  disabledStyle?: boolean;
  selected?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

/**
 * NavItem is a functional component that renders a button with various styles based on the props.
 */
const NavItem: React.FC<NavItemProps> = ({
  children,
  className,
  disabled,
  disabledStyle,
  selected,
  onClick,
  ...props
}) => (
  <button
    className={twMerge(
      cn(
        'ring-grey-300 lg:hover:ring-grey-800 flex items-center justify-center gap-2 rounded-md px-3 py-2.5 text-sm leading-5 whitespace-nowrap ring-1 ring-inset',
        selected && disabledStyle
          ? 'text-text-primary ring-grey-800 font-medium line-through shadow-xs ring-2'
          : selected
            ? 'text-text-primary ring-grey-800 font-medium shadow-xs ring-2'
            : disabledStyle
              ? 'text-text-light-bg-secondary ring-grey-100 lg:hover:ring-grey-100 line-through'
              : 'text-text-secondary font-normal',
        className
      )
    )}
    disabled={disabled}
    onClick={(event) => {
      event.preventDefault();
      onClick(event);
    }}
    {...props}
  >
    {children}
  </button>
);

export default NavItem;
